import type { Addons } from '../simulation/Simulation'

// `decision_reason` values returned by the backend for a reproved project (`GET /project/{id}`).
// Any other value, `null` or a missing field keeps the default reproved message.
export const PROJECT_DECISION_REASON = {
  ONLY_BATTERY_LIMIT_EXCEEDED: 'only_battery_limit_exceeded',
} as const

interface Guarantor {
  id: string
  document: string
  birth_date: string
  border_line: boolean
  created_at: string
  customer_second_financing_policy: boolean
  decision_pre_analysis: number
  max_approved_project_value: number
  max_financing_value: number
  max_grace_period: number
  max_installments: number
  min_approved_project_value: number
  min_installment_value: number
  pre_approved_value: number
  project_name: string
  project_state: string
  risk_class: string | null
  status: string
}

export interface Project {
  id: string
  person_type: string
  document: string
  representative_document: string
  project_value: number
  complete: boolean
  system_power: number
  grace_period: number
  due_day: null | number
  first_due_date: null | string
  commission: number
  risk_class: string
  down_payment: number
  bill_value?: number
  max_installments: number
  min_installments?: number
  max_grace_period: number
  project_name: string
  max_approved_project_value?: number
  min_approved_project_value?: number
  max_financing_value?: number
  pre_approved_value: number
  selected_installment: number
  products_applieds: null
  decision_pre_analysis?: number
  is_onflex_partner?: boolean
  has_energy_bill_analysis?: boolean
  installments: number[]
  partner_id: number
  user_id: number
  new_journey?: boolean | null
  created_at: string
  credit_analysis_status: string
  decision_pre_analisys?: number
  project_status: string | null
  is_formalized: boolean
  gained_points?: number
  insurance_commission?: number
  commission_raw?: number
  addons: Addons[]
  selected_installments: {
    addons: Addons[]
    financing_value: number
    down_payment: number
    commission: number
    taxa_de_juros: number
    installment_value: number
    cet: string
    taxa_cadastro: number
    is_combo: boolean
    combo_conecte?: boolean
    is_from_suggested: boolean
    grace_period: number
    due_day: null | number
    first_due_date: null | string
    installments: number
    commission_raw?: number
    is_combo_connect?: boolean
  }
  bnpl?: {
    decision_pre_analysis?: number
    min_entry_value?: number
    max_installments?: number
    pre_approved_value?: number
  } | null
  risk_info: {
    title: string
    description: string
    todo: string
    reason: string
    decision: number
  }
  project_state?: string
  can_select_ampera?: boolean
  guarantor?: Guarantor
  system_type: string | null
  decision_reason?: null | string
  installments_conditions?: {
    suggested_installments?: number | null
    suggested_installments_value?: number | null
  } | null
  has_combo_enabled?: boolean
  combo_conecte_only?: boolean
}
